/**
 * Converts a display name into a URL-safe slug.
 * Example: "Fintech & SaaS" → "fintech-saas"
 */
export const slugify = (name: string): string =>
  name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
